import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import BudgetRequestsDataGrid from 'src/components//BudgetRequestsDataGrid/BudgetRequestsDataGrid'
import BudgetRequestsTableLarge from 'src/components/BudgetRequestsTableLarge/BudgetRequestsTableLarge'
import BudgetRequestsTableSmall from 'src/components/BudgetRequestsTableSmall/BudgetRequestsTableSmall'
import { BudgetRequestListModel } from 'src/models/budgetRequest.models'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { css } from 'styled-components'

interface BudgetRequestsTableProps {
  className?: string
  budgetRequests: BudgetRequestListModel[]
  isSlim: boolean
  isApprover?: boolean
  clientHeight?: number
}

const BudgetRequestsTable: React.FC<BudgetRequestsTableProps> = (props) => {
  const showNewBudgetsTable = useSelector(
    selectFeatureFlaggerFromState,
  )?.show_new_budgets_table
  return (
    <div>
      {showNewBudgetsTable ? (
        <BudgetRequestsDataGrid
          budgetRequests={props.budgetRequests}
          isApprover={props.isApprover}
          clientHeight={props.clientHeight}
        />
      ) : (
        <>
          <div
            css={css`
              display: none;

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: block;
              `)};

              ${props.isSlim &&
              css`
                display: block;
              `};
            `}
          >
            <BudgetRequestsTableSmall
              budgetRequests={props.budgetRequests}
              isSlim={props.isSlim}
              isApprover={props.isApprover}
            />
          </div>
          <div
            css={css`
              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: none;
              `)};

              ${props.isSlim &&
              css`
                display: none;
              `};
            `}
          >
            <BudgetRequestsTableLarge
              budgetRequests={props.budgetRequests}
              isApprover={props.isApprover}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default BudgetRequestsTable
